<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

defineProps<{ count?: number }>()
</script>

<template>
  <h1 :class="twMerge('flex gap-1 text-display-sm-24px-default', String($attrs.class || ''))">
    <slot />

    <!-- Count gets hidden when it's 0 and animates in and out from below -->
    <Transition
      enter-active-class="transition duration-200"
      enter-from-class="opacity-0 translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition duration-200"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-1"
    >
      <span
        v-if="count"
        class="text-sm-12px-default text-text-warning"
      >
        {{ count }}
      </span>
    </Transition>
  </h1>
</template>
